import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

function PartnershipsAnswer(props) {
  const { questionData } = props
  const answers = questionData?.answer?.answer_object
  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Participação Societária</h2>
      <div className={classes.formWrapper}>
        <h3>Pergunta:</h3>
        <p>{questionData.text}</p>

        {answers && (
          <React.Fragment>
            <h3>Resposta:</h3>
            <div className={classes.subject}>
              <p>
                <span>Serviços oferecidos</span> {answers.provided_services}
              </p>
              <p>
                <span>Cargo na empresa: </span>
                {answers.position_in_the_company}
              </p>
              <p>
                <span>Funções/Atividades desempenhadas:</span>{' '}
                {answers.developed_activities}
              </p>
              <p>
                <span>Empresa atua com valores mobiliários:</span>{' '}
                {answers.company_operate_with_securities ? 'sim' : 'não'}
              </p>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

PartnershipsAnswer.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default PartnershipsAnswer
